export const Status = {
  INIT: "INIT",
  LOADING: "LOADING",
  DONE: "DONE",
  ERROR: "ERROR"
};
